/**
 * Button Price Manager
 * Gère la mise à jour dynamique du prix dans le bouton "Ajouter au panier"
 * Compatible avec flavor-cards-addon.js
 */

(function() {
  'use strict';

  class ButtonPriceManager {
    constructor() {
      this.submitButton = null;
      this.priceDisplay = null;
      this.basePrice = 0;
      this.init();
    }

    init() {
      // Attendre que le DOM soit prêt
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup());
      } else {
        this.setup();
      }
    }

    setup() {
      // Trouver le bouton submit et l'élément de prix
      this.submitButton = document.querySelector('.product-form__submit');
      this.priceDisplay = document.querySelector('[data-price-display]');
      
      if (!this.submitButton || !this.priceDisplay) {
        console.warn('Button or price display not found');
        return;
      }

      // Récupérer le prix de base
      const basePrice = this.submitButton.dataset.productPrice;
      if (basePrice) {
        this.basePrice = parseInt(basePrice);
      }

      // Écouter les événements de changement de prix depuis flavor-cards
      document.addEventListener('flavorCardsPrice:change', (e) => {
        this.updatePrice(e.detail);
      });

      // Écouter les changements de variante (si pas de flavor cards)
      const variantSelects = document.querySelectorAll('.product-form select[name="id"]');
      variantSelects.forEach(select => {
        select.addEventListener('change', () => {
          this.updatePriceFromVariant();
        });
      });

      // Écouter les événements de changement de variante via radio buttons
      const variantRadios = document.querySelectorAll('.product-form input[type="radio"][name="id"]');
      variantRadios.forEach(radio => {
        radio.addEventListener('change', () => {
          this.updatePriceFromVariant();
        });
      });
    }

    updatePrice(detail) {
      if (!this.priceDisplay) return;

      const { totalPrice, totalPriceBeforeDiscount, totalCompareAtPrice, hasSelections, discount } = detail;

      if (hasSelections && totalPrice > 0) {
        // Vérifier s'il y a un discount appliqué
        const hasDiscount = discount && discount.type !== 'none' && totalPriceBeforeDiscount > totalPrice;

        if (hasDiscount) {
          // Déterminer le prix barré à afficher :
          // - Si compare_at_price existe, l'utiliser (prix original avant toutes remises)
          // - Sinon, utiliser totalPriceBeforeDiscount (prix intermédiaire)
          const priceToStrike = (totalCompareAtPrice && totalCompareAtPrice > totalPriceBeforeDiscount)
            ? totalCompareAtPrice
            : totalPriceBeforeDiscount;

          const formattedPriceBeforeDiscount = this.formatPrice(priceToStrike);
          const formattedPrice = this.formatPrice(totalPrice);

          this.priceDisplay.innerHTML = `
            <span class="price-discounted">${formattedPrice}</span>
            <span class="price-before-discount">${formattedPriceBeforeDiscount}</span>
          `;
        } else {
          // Pas de discount, afficher le prix normalement
          const formattedPrice = this.formatPrice(totalPrice);
          this.priceDisplay.textContent = formattedPrice;
        }
      } else {
        // Revenir au prix de base
        this.updatePriceFromVariant();
      }
    }

    updatePriceFromVariant() {
      if (!this.priceDisplay || !this.submitButton) return;

      // Chercher la variante sélectionnée
      const variantInput = document.querySelector('.product-form input[name="id"]');
      
      if (variantInput && variantInput.value) {
        const variantId = variantInput.value;
        
        // Chercher le prix dans les données du produit
        // Option 1: depuis un data attribute
        const newPrice = this.submitButton.dataset.productPrice;
        
        if (newPrice) {
          const price = parseInt(newPrice);
          const formattedPrice = this.formatPrice(price);
          this.priceDisplay.textContent = formattedPrice;
        }
      }
    }

    formatPrice(priceInCents) {
      // Convertir les centimes en euros
      const priceInEuros = priceInCents / 100;
      
      // Formater avec 2 décimales obligatoires et le symbole €
      return priceInEuros.toFixed(2).replace('.', ',') + '€';
    }

    // Méthode publique pour mise à jour manuelle
    setPrice(priceInCents) {
      if (!this.priceDisplay) return;
      const formattedPrice = this.formatPrice(priceInCents);
      this.priceDisplay.textContent = formattedPrice;
    }

    // Méthode publique pour réinitialiser au prix de base
    reset() {
      if (this.basePrice > 0) {
        this.setPrice(this.basePrice);
      }
    }
  }

  // Initialiser le manager
  const manager = new ButtonPriceManager();

  // Exporter globalement pour accès externe
  window.ButtonPriceManager = manager;

  // Fonction globale pour rafraîchir le prix (pour compatibilité)
  window.refreshButtonPrice = function() {
    manager.updatePriceFromVariant();
  };

  // Signaler que le manager est prêt
  // Dispatcher un event pour que FlavorCardsAddon puisse re-dispatcher son prix
  const readyEvent = new CustomEvent('buttonPriceManagerReady');
  document.dispatchEvent(readyEvent);

})();
